/**
 * KAN-341: раздел «Биллинг» — всё про деньги в одном месте.
 *
 * Раньше тариф был вкладкой Настроек, а витрина — внутри голосового пакета:
 * «сколько я плачу» приходилось искать в двух разных экранах, ни один из
 * которых про деньги не назывался.
 *
 * Раздел виден только владельцу: суммы, история платежей и кнопка отмены —
 * не то, что показывают каждому сотруднику организации.
 */
import { useEffect, useState } from 'react';
import { CreditCard } from 'lucide-react';
import { PageLayout } from '@/components/layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { CurrentTariff } from '@/components/billing/CurrentTariff';
import { VoicePackage } from '@/components/billing/VoicePackage';
import { PaymentHistory } from '@/components/billing/PaymentHistory';

export function BillingPage() {
  const [activeTab, setActiveTab] = useState('tariff');

  useEffect(() => {
    document.title = 'Биллинг — SMETA AI';
  }, []);

  return (
    <PageLayout
      data-testid="billing-page"
      title="Биллинг"
      subtitle={<span className="hidden sm:inline">Тариф, пакет минут и платежи организации</span>}
      titleIcon={
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-blue-600">
          <CreditCard className="h-5 w-5 text-white" />
        </div>
      }
      breadcrumbs={[{ label: 'Главная', href: '/' }, { label: 'Биллинг' }]}>
      <div className="rounded-lg bg-white shadow" data-testid="billing-tabs-container">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <div className="overflow-x-auto border-b border-gray-200 px-4 pt-4 sm:px-6">
            <TabsList className="flex-nowrap gap-4 bg-transparent">
              <TabsTrigger
                data-testid="tab-tariff"
                value="tariff"
                className="rounded-none pb-3 data-[state=active]:border-b-2 data-[state=active]:border-blue-600">
                Тариф
              </TabsTrigger>
              <TabsTrigger
                data-testid="tab-voice-package"
                value="voice"
                className="rounded-none pb-3 data-[state=active]:border-b-2 data-[state=active]:border-blue-600">
                Голосовой пакет
              </TabsTrigger>
              <TabsTrigger
                data-testid="tab-payments"
                value="payments"
                className="rounded-none pb-3 data-[state=active]:border-b-2 data-[state=active]:border-blue-600">
                История платежей
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="tariff" className="p-4 sm:p-6">
            <CurrentTariff />
          </TabsContent>

          <TabsContent value="voice" className="p-4 sm:p-6">
            <VoicePackage />
          </TabsContent>

          <TabsContent value="payments" className="p-4 sm:p-6">
            <PaymentHistory />
          </TabsContent>
        </Tabs>
      </div>
    </PageLayout>
  );
}
